var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingStartup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 423,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47,
    fill: "#76D1FF"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.133 119.429L22.547 95.171a19.908 19.908 0 01-12.089-9.27c-2.64-4.57-3.355-10-1.989-15.098a19.898 19.898 0 019.277-12.08 19.921 19.921 0 0115.108-1.988l142.733 38.218a19.922 19.922 0 0020.948-7.107 19.885 19.885 0 001.447-22.06 19.908 19.908 0 00-12.088-9.27l-64.97-17.401a19.908 19.908 0 01-12.091-9.27 19.888 19.888 0 017.287-27.18A19.921 19.921 0 01131.228.678l330.053 88.375a19.918 19.918 0 0112.09 9.27 19.891 19.891 0 01-7.287 27.182 19.906 19.906 0 01-15.11 1.988l-51.391-13.76a19.916 19.916 0 00-24.384 14.069 19.885 19.885 0 007.111 20.934 19.908 19.908 0 006.968 3.433l87.965 23.555c5.1 1.365 9.449 4.7 12.089 9.27a19.885 19.885 0 01-7.287 27.179 19.907 19.907 0 01-15.108 1.988l-54.897-14.7a19.915 19.915 0 00-24.384 14.069 19.885 19.885 0 007.111 20.934 19.908 19.908 0 006.968 3.433l3.895 1.044a19.904 19.904 0 0114.587 16.63 19.857 19.857 0 01-.512 7.749 19.892 19.892 0 01-9.276 12.082 19.907 19.907 0 01-15.108 1.988l-3.694-.988a19.911 19.911 0 00-24.384 14.069 19.885 19.885 0 007.111 20.935 19.92 19.92 0 006.967 3.433l54.695 14.645a19.91 19.91 0 0112.089 9.271 19.886 19.886 0 01-7.288 27.178 19.918 19.918 0 01-15.108 1.988l-99.941-26.762a19.929 19.929 0 00-15.108 1.988 19.89 19.89 0 00-2.164 33.018 19.925 19.925 0 006.968 3.433l16.017 4.288a19.912 19.912 0 0112.089 9.27 19.89 19.89 0 01-7.287 27.179 19.912 19.912 0 01-15.108 1.987L66.698 354.181a19.908 19.908 0 01-12.09-9.27 19.886 19.886 0 011.448-22.061 19.913 19.913 0 0120.948-7.106l7.487 2.004a19.92 19.92 0 0015.106-1.986 19.884 19.884 0 002.165-33.013 19.911 19.911 0 00-6.968-3.433l-49.225-13.183a19.923 19.923 0 01-12.09-9.271 19.877 19.877 0 01-1.99-15.098 19.895 19.895 0 019.277-12.081 19.927 19.927 0 0115.108-1.988l69.799 18.688a19.93 19.93 0 0015.108-1.988 19.89 19.89 0 007.285-27.177 19.916 19.916 0 00-12.088-9.268l-49.422-13.234a19.903 19.903 0 01-14.587-16.621 19.894 19.894 0 019.782-19.834 19.931 19.931 0 0115.111-1.99l5.964 1.597a19.923 19.923 0 0015.108-1.987 19.896 19.896 0 007.289-27.181 19.904 19.904 0 00-12.09-9.271z",
    opacity: 0.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.89 138.338l5.24 1.403c10.62 2.844 16.924 13.754 14.078 24.368l-.001.003c-2.846 10.614-13.763 16.913-24.384 14.069l-5.24-1.403C8.964 173.934 2.66 163.025 5.507 152.41v-.003c2.846-10.614 13.764-16.913 24.385-14.069z",
    opacity: 0.47
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.683 301.475l-6.786-9.693a.61.61 0 00-.848-.149l-6.926 4.842a.61.61 0 00-.15.847l6.786 9.693a4.4 4.4 0 006.122 1.081l.72-.504a4.388 4.388 0 001.082-6.117z",
    fill: "#4E4E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.683 301.475l-6.786-9.693a.61.61 0 00-.848-.149l-6.926 4.842a.61.61 0 00-.15.847l6.786 9.693a4.4 4.4 0 006.122 1.081l.72-.504a4.388 4.388 0 001.082-6.117z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M431.683 301.475l-6.786-9.693a.61.61 0 00-.848-.149l-6.926 4.842a.61.61 0 00-.15.847l6.786 9.693a4.4 4.4 0 006.122 1.081l.72-.504a4.388 4.388 0 001.082-6.117z",
    fill: "#4E4E4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431.683 301.475l-6.786-9.693a.61.61 0 00-.848-.149l-6.926 4.842a.61.61 0 00-.15.847l6.786 9.693a4.4 4.4 0 006.122 1.081l.72-.504a4.388 4.388 0 001.082-6.117z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 301.638c-15.823 0-28.65-12.819-28.65-28.631 0-15.813 12.827-28.631 28.65-28.631 15.823 0 28.65 12.818 28.65 28.631 0 15.812-12.827 28.631-28.65 28.631z",
    fill: "#4E4E4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 301.638c-15.823 0-28.65-12.819-28.65-28.631 0-15.813 12.827-28.631 28.65-28.631 15.823 0 28.65 12.818 28.65 28.631 0 15.812-12.827 28.631-28.65 28.631z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 301.638c-15.823 0-28.65-12.819-28.65-28.631 0-15.813 12.827-28.631 28.65-28.631 15.823 0 28.65 12.818 28.65 28.631 0 15.812-12.827 28.631-28.65 28.631z",
    fill: "#4E4E4E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 301.638c-15.823 0-28.65-12.819-28.65-28.631 0-15.813 12.827-28.631 28.65-28.631 15.823 0 28.65 12.818 28.65 28.631 0 15.812-12.827 28.631-28.65 28.631z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 295.29c-12.316 0-22.3-9.977-22.3-22.284 0-12.307 9.984-22.284 22.3-22.284 12.315 0 22.299 9.977 22.299 22.284 0 12.307-9.984 22.284-22.299 22.284z",
    fill: "#4E4E4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 295.29c-12.316 0-22.3-9.977-22.3-22.284 0-12.307 9.984-22.284 22.3-22.284 12.315 0 22.299 9.977 22.299 22.284 0 12.307-9.984 22.284-22.299 22.284z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 295.29c-12.316 0-22.3-9.977-22.3-22.284 0-12.307 9.984-22.284 22.3-22.284 12.315 0 22.299 9.977 22.299 22.284 0 12.307-9.984 22.284-22.299 22.284z",
    fill: "#4E4E4E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M405.625 295.29c-12.316 0-22.3-9.977-22.3-22.284 0-12.307 9.984-22.284 22.3-22.284 12.315 0 22.299 9.977 22.299 22.284 0 12.307-9.984 22.284-22.299 22.284z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M420.202 268.381a39.924 39.924 0 00-.95-1.974c-1.495-2.929-3.283-5.964-6.137-7.758-2.423-1.524-5.812-2.121-8.438-.773-2.278 1.169-3.651 3.573-5.729 5.069a37.565 37.565 0 01-4.357 2.289 6.54 6.54 0 00-3.353 3.447c-.704 2.148.456 4.44.468 6.7a6.664 6.664 0 01-1 3.531 3.438 3.438 0 00-.77 1.739 2.284 2.284 0 001.509 1.811c2.309 1.09 5.006.697 7.546.422 2.54-.274 5.353-.332 7.361 1.247a21.398 21.398 0 012.277 2.453 3.585 3.585 0 005.496.56 23.511 23.511 0 004.685-5.309 14.43 14.43 0 002.79-5.763c.457-2.615-.304-5.231-1.398-7.691z",
    fill: "#4E4E4E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M420.202 268.381a39.924 39.924 0 00-.95-1.974c-1.495-2.929-3.283-5.964-6.137-7.758-2.423-1.524-5.812-2.121-8.438-.773-2.278 1.169-3.651 3.573-5.729 5.069a37.565 37.565 0 01-4.357 2.289 6.54 6.54 0 00-3.353 3.447c-.704 2.148.456 4.44.468 6.7a6.664 6.664 0 01-1 3.531 3.438 3.438 0 00-.77 1.739 2.284 2.284 0 001.509 1.811c2.309 1.09 5.006.697 7.546.422 2.54-.274 5.353-.332 7.361 1.247a21.398 21.398 0 012.277 2.453 3.585 3.585 0 005.496.56 23.511 23.511 0 004.685-5.309 14.43 14.43 0 002.79-5.763c.457-2.615-.304-5.231-1.398-7.691z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M401.115 289.877a1.383 1.383 0 11-.002-2.766 1.383 1.383 0 01.002 2.766z",
    fill: "#4E4E4E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M401.115 289.877a1.383 1.383 0 11-.002-2.766 1.383 1.383 0 01.002 2.766z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M404.718 289.962a.958.958 0 11-.001-1.917.958.958 0 01.001 1.917z",
    fill: "#4E4E4E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M404.718 289.962a.958.958 0 11-.001-1.917.958.958 0 01.001 1.917z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M397.844 288.075a.869.869 0 110-1.738.869.869 0 010 1.738z",
    fill: "#4E4E4E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M397.844 288.075a.869.869 0 110-1.738.869.869 0 010 1.738z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M407.75 289.986a.623.623 0 110-1.246.623.623 0 010 1.246z",
    fill: "#4E4E4E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M407.75 289.986a.623.623 0 110-1.246.623.623 0 010 1.246z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M395.099 286.669a.38.38 0 110-.76.38.38 0 010 .76z",
    fill: "#4E4E4E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M395.099 286.669a.38.38 0 110-.76.38.38 0 010 .76z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M422.928 268.633a.892.892 0 110-1.784.892.892 0 010 1.784z",
    fill: "#4E4E4E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M422.928 268.633a.892.892 0 110-1.784.892.892 0 010 1.784z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M398.65 258.211a.839.839 0 110-1.677.839.839 0 010 1.677z",
    fill: "#4E4E4E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M398.65 258.211a.839.839 0 110-1.677.839.839 0 010 1.677z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M393.197 262.262a.76.76 0 11-.001-1.519.76.76 0 01.001 1.519z",
    fill: "#4E4E4E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M393.197 262.262a.76.76 0 11-.001-1.519.76.76 0 01.001 1.519z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M392.573 263.987a.332.332 0 110-.664.332.332 0 010 .664z",
    fill: "#4E4E4E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M392.573 263.987a.332.332 0 110-.664.332.332 0 010 .664z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 294.415l-6.791-9.695a.61.61 0 00-.848-.15l-6.928 4.847a.606.606 0 00-.15.847l6.791 9.695a4.398 4.398 0 006.124 1.08l.72-.504a4.394 4.394 0 001.082-6.12z",
    fill: "#fff",
    stroke: "#E6F3FF",
    strokeWidth: 1.759,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M430.271 284.572a.61.61 0 01.847.151l3.058 4.364a32.219 32.219 0 01-3.755 3.071 32.66 32.66 0 01-4.17 2.474l-3.058-4.366a.604.604 0 01.149-.847l6.929-4.847z",
    fill: "#4E4E4E",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 294.415l-6.791-9.695a.61.61 0 00-.848-.15l-6.928 4.847a.606.606 0 00-.15.847l6.791 9.695a4.398 4.398 0 006.124 1.08l.72-.504a4.394 4.394 0 001.082-6.12v0z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M411.976 294.452c-15.823 0-28.65-12.818-28.65-28.631 0-15.812 12.827-28.631 28.65-28.631 15.823 0 28.65 12.819 28.65 28.631 0 15.813-12.827 28.631-28.65 28.631z",
    fill: "#fff",
    stroke: "#E6F3FF",
    strokeWidth: 1.759,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M411.976 294.452c-15.823 0-28.65-12.818-28.65-28.631 0-15.812 12.827-28.631 28.65-28.631 15.823 0 28.65 12.819 28.65 28.631 0 15.813-12.827 28.631-28.65 28.631z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M411.976 288.105c-12.315 0-22.299-9.977-22.299-22.285 0-12.307 9.984-22.284 22.299-22.284 12.316 0 22.299 9.977 22.299 22.284 0 12.308-9.983 22.285-22.299 22.285z",
    fill: "#845B5B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M411.976 288.105c-12.315 0-22.299-9.977-22.299-22.285 0-12.307 9.984-22.284 22.299-22.284 12.316 0 22.299 9.977 22.299 22.284 0 12.308-9.983 22.285-22.299 22.285z",
    stroke: "#46505C",
    strokeWidth: 1.759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M426.553 261.195a41.288 41.288 0 00-.949-1.974c-1.496-2.928-3.284-5.963-6.137-7.758-2.424-1.524-5.812-2.12-8.438-.773-2.278 1.169-3.651 3.574-5.729 5.069a37.631 37.631 0 01-4.358 2.285 6.545 6.545 0 00-3.353 3.444c-.704 2.149.456 4.441.468 6.7a6.655 6.655 0 01-1 3.531 3.438 3.438 0 00-.77 1.739 2.288 2.288 0 001.508 1.812c2.311 1.089 5.008.697 7.548.421 2.54-.275 5.352-.331 7.36 1.247a21.407 21.407 0 012.277 2.454 3.59 3.59 0 004.17 1.389 3.578 3.578 0 001.327-.829 23.558 23.558 0 004.684-5.31 14.42 14.42 0 002.788-5.758c.464-2.613-.302-5.229-1.396-7.689zm-19.087 21.496a1.384 1.384 0 110-2.769 1.384 1.384 0 010 2.769zm3.603.085a.959.959 0 110-1.918.959.959 0 010 1.918zm-6.874-1.887a.869.869 0 110-1.737.869.869 0 010 1.737zm9.907 1.911a.622.622 0 11-.002-1.244.622.622 0 01.002 1.244zm-12.652-3.317a.38.38 0 110-.76.38.38 0 010 .76zm27.83-18.037a.891.891 0 11-.001-1.783.891.891 0 01.001 1.783zm-24.278-10.421a.839.839 0 110-1.678.839.839 0 010 1.678zm-5.454 4.05a.76.76 0 110-1.52.76.76 0 010 1.52zm-.624 1.726a.333.333 0 11.001-.665.333.333 0 01-.001.665z",
    fill: "#845B5B",
    opacity: 0.33
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M410.022 269.419a1.758 1.758 0 11-.002-3.516 1.758 1.758 0 01.002 3.516zm5.729-5.432a3.077 3.077 0 113.078-3.076 3.077 3.077 0 01-3.078 3.076z",
    fill: "#845B5B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 173.624h204.038c6.801 0 12.313 5.509 12.313 12.305v15.361c0 6.795-5.512 12.304-12.313 12.304H135.743c-6.8 0-12.313-5.509-12.313-12.304v-15.361c0-6.796 5.513-12.305 12.313-12.305z",
    fill: "#4E4E4E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 173.624h204.038c6.801 0 12.313 5.509 12.313 12.305v15.361c0 6.795-5.512 12.304-12.313 12.304H135.743c-6.8 0-12.313-5.509-12.313-12.304v-15.361c0-6.796 5.513-12.305 12.313-12.305z",
    stroke: "#000",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 173.624h204.038c6.801 0 12.313 5.509 12.313 12.305v15.361c0 6.795-5.512 12.304-12.313 12.304H135.743c-6.8 0-12.313-5.509-12.313-12.304v-15.361c0-6.796 5.513-12.305 12.313-12.305z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M339.782 173.624H135.743a12.315 12.315 0 00-8.706 3.604 12.3 12.3 0 00-3.607 8.701v17.962a7.52 7.52 0 007.519 7.514h213.626a7.52 7.52 0 007.519-7.514v-17.962a12.3 12.3 0 00-3.607-8.701 12.315 12.315 0 00-8.706-3.604h.001z",
    fill: "#4E4E4E",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 173.624h204.038c6.801 0 12.313 5.509 12.313 12.305v15.361c0 6.795-5.512 12.304-12.313 12.304H135.743c-6.8 0-12.313-5.509-12.313-12.304v-15.361c0-6.796 5.513-12.305 12.313-12.305z",
    fill: "#4E4E4E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M135.743 173.624h204.038c6.801 0 12.313 5.509 12.313 12.305v15.361c0 6.795-5.512 12.304-12.313 12.304H135.743c-6.8 0-12.313-5.509-12.313-12.304v-15.361c0-6.796 5.513-12.305 12.313-12.305z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M139.261 208.836v-30.709h197.003v30.709H139.261z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M139.261 208.836v-30.709h197.003v30.709H139.261z",
    fill: "#4E4E4E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.261 208.836v-30.709h197.003v30.709H139.261z",
    stroke: "#46505C",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M135.742 213.594H339.78c6.801 0 12.313 5.509 12.313 12.304v126.561c0 6.795-5.512 12.304-12.313 12.304H135.742c-6.8 0-12.313-5.509-12.313-12.304V225.898c0-6.795 5.513-12.304 12.313-12.304z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M126.947 352.459V225.898c0-4.854 3.937-8.789 8.795-8.789H339.78c4.858 0 8.795 3.935 8.795 8.789v126.561c0 4.854-3.937 8.789-8.795 8.789H135.742c-4.858 0-8.795-3.935-8.795-8.789z",
    fill: "#4E4E4E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M126.947 352.459V225.898c0-4.854 3.937-8.789 8.795-8.789H339.78c4.858 0 8.795 3.935 8.795 8.789v126.561c0 4.854-3.937 8.789-8.795 8.789H135.742c-4.858 0-8.795-3.935-8.795-8.789z",
    stroke: "#E6F3FF",
    strokeWidth: 1.759,
    strokeMiterlimit: 10
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M251.877 357.889h-28.231a3.517 3.517 0 00-3.518 3.515v3.358h35.267v-3.358a3.515 3.515 0 00-3.518-3.515z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M135.742 213.594H339.78c6.801 0 12.313 5.509 12.313 12.304v126.561c0 6.795-5.512 12.304-12.313 12.304H135.742c-6.8 0-12.313-5.509-12.313-12.304V225.898c0-6.795 5.513-12.304 12.313-12.304z",
    fill: "#4E4E4E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M135.742 213.594H339.78c6.801 0 12.313 5.509 12.313 12.304v126.561c0 6.795-5.512 12.304-12.313 12.304H135.742c-6.8 0-12.313-5.509-12.313-12.304V225.898c0-6.795 5.513-12.304 12.313-12.304z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.261 225.39h197.002a2.637 2.637 0 012.639 2.636v75.585a2.638 2.638 0 01-2.639 2.637H139.261a2.638 2.638 0 01-2.639-2.637v-75.585a2.637 2.637 0 012.639-2.636z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M300.13 286.473h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879H300.13a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M300.13 286.473h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879H300.13a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M319.161 286.473h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M319.161 286.473h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M204.978 286.473h86.675a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-86.675a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M204.978 286.473h86.675a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-86.675a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M185.947 286.473H196.5a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M185.947 286.473H196.5a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M158.121 293.394h7.036c.485 0 .879.393.879.878v3.626a.88.88 0 01-.879.879h-7.036a.88.88 0 01-.88-.879v-3.626c0-.485.394-.878.88-.878z",
    fill: "#4E4E4E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M158.121 293.394h7.036c.485 0 .879.393.879.878v3.626a.88.88 0 01-.879.879h-7.036a.88.88 0 01-.88-.879v-3.626c0-.485.394-.878.88-.878z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M158.121 286.473h7.036c.485 0 .879.393.879.879v3.625a.88.88 0 01-.879.879h-7.036a.88.88 0 01-.88-.879v-3.625a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M158.121 286.473h7.036c.485 0 .879.393.879.879v3.625a.88.88 0 01-.879.879h-7.036a.88.88 0 01-.88-.879v-3.625a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 293.394h7.036c.486 0 .879.393.879.878v3.626a.879.879 0 01-.879.879h-7.036a.879.879 0 01-.879-.879v-3.626c0-.485.393-.878.879-.878z",
    fill: "#4E4E4E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 293.394h7.036c.486 0 .879.393.879.878v3.626a.879.879 0 01-.879.879h-7.036a.879.879 0 01-.879-.879v-3.626c0-.485.393-.878.879-.878z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M170.433 293.394h7.036c.486 0 .88.393.88.878v3.626a.88.88 0 01-.88.879h-7.036a.88.88 0 01-.879-.879v-3.626c0-.485.394-.878.879-.878z",
    fill: "#4E4E4E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M170.433 293.394h7.036c.486 0 .88.393.88.878v3.626a.88.88 0 01-.88.879h-7.036a.88.88 0 01-.879-.879v-3.626c0-.485.394-.878.879-.878z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M301.889 268.965h27.826a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-27.826a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M301.889 268.965h27.826a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-27.826a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M282.7 268.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879H282.7a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M282.7 268.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879H282.7a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M263.669 268.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M263.669 268.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M244.638 268.965h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M244.638 268.965h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M225.608 268.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M225.608 268.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M206.577 268.965h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M206.577 268.965h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M187.546 268.965H198.1c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M187.546 268.965H198.1c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 268.965h31.661a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-31.661a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 268.965h31.661a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-31.661a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M289.577 250.965h10.553a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M289.577 250.965h10.553a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M308.608 250.965h21.107a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-21.107a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M308.608 250.965h21.107a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-21.107a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M270.546 250.965H281.1c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M270.546 250.965H281.1c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M251.516 250.965h10.553a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M251.516 250.965h10.553a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M232.485 250.965h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M232.485 250.965h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M213.454 250.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M213.454 250.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M194.423 250.965h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M194.423 250.965h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M175.393 250.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M175.393 250.965h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 250.965h21.107a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-21.107a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 250.965h21.107a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-21.107a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M299.9 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879H299.9a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M299.9 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879H299.9a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M319.161 233.739h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879z",
    fill: "#4E4E4E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M319.161 233.739h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M280.638 233.739h10.554c.486 0 .879.394.879.879v10.547a.879.879 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M280.638 233.739h10.554c.486 0 .879.394.879.879v10.547a.879.879 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M261.377 233.739h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M261.377 233.739h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M242.116 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M242.116 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M222.854 233.739h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M222.854 233.739h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M203.592 233.739h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879z",
    fill: "#4E4E4E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M203.592 233.739h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M184.331 233.739h10.554c.486 0 .879.394.879.879v10.547a.879.879 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M184.331 233.739h10.554c.486 0 .879.394.879.879v10.547a.879.879 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M165.07 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879H165.07a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    fill: "#4E4E4E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M165.07 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879H165.07a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 233.739h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879z",
    fill: "#4E4E4E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M145.808 233.739h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M300.13 286.473h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879H300.13a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879zm19.031 0h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879zm-114.183 0h86.675a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-86.675a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-19.031 0H196.5a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-27.826 6.921h7.036c.485 0 .879.393.879.878v3.626a.88.88 0 01-.879.879h-7.036a.88.88 0 01-.88-.879v-3.626c0-.485.394-.878.88-.878zm0-6.921h7.036c.485 0 .879.393.879.879v3.625a.88.88 0 01-.879.879h-7.036a.88.88 0 01-.88-.879v-3.625a.88.88 0 01.88-.879zm-12.313 6.921h7.036c.486 0 .879.393.879.878v3.626a.879.879 0 01-.879.879h-7.036a.879.879 0 01-.879-.879v-3.626c0-.485.393-.878.879-.878zm24.625 0h7.036c.486 0 .88.393.88.878v3.626a.88.88 0 01-.88.879h-7.036a.88.88 0 01-.879-.879v-3.626c0-.485.394-.878.879-.878zm131.456-24.429h27.826a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-27.826a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879zm-19.189 0h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879H282.7a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-19.031 0h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-19.031 0h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879zm-19.03 0h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-19.031 0h10.554a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879zm-19.031 0H198.1c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879zm-41.738 0h31.661a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-31.661a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879zm143.769-18h10.553a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm19.031 0h21.107a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-21.107a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-38.062 0H281.1c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879zm-19.03 0h10.553a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-19.031 0h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879zm-19.031 0h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-19.031 0h10.554c.486 0 .879.393.879.879v10.546a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.546c0-.486.394-.879.879-.879zm-19.03 0h10.554c.485 0 .879.393.879.879v10.546a.879.879 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.546a.88.88 0 01.88-.879zm-29.585 0h21.107a.88.88 0 01.88.879v10.546a.88.88 0 01-.88.879h-21.107a.878.878 0 01-.879-.879v-10.546c0-.486.393-.879.879-.879zM299.9 233.739h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879H299.9a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm19.261 0h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879zm-38.523 0h10.554c.486 0 .879.394.879.879v10.547a.879.879 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879zm-19.261 0h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm-19.261 0h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879zm-19.261 0h10.554c.486 0 .879.394.879.879v10.547a.879.879 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879zm-19.261 0h10.553a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879H165.07a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.393-.879.879-.879zm166.71-28.041H163.007v11.818a3.515 3.515 0 003.518 3.515H309a3.517 3.517 0 003.518-3.515v-11.818z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M166.525 217.515H309a3.518 3.518 0 003.518-3.516v3.516c0 .932-.371 1.826-1.031 2.485a3.514 3.514 0 01-2.487 1.03H166.525a3.516 3.516 0 01-3.518-3.515v-3.516a3.513 3.513 0 003.518 3.516z",
    fill: "#4E4E4E",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M312.518 205.698H163.007v11.818a3.515 3.515 0 003.518 3.515H309a3.517 3.517 0 003.518-3.515v-11.818z",
    fill: "#4E4E4E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M312.518 205.698H163.007v11.818a3.515 3.515 0 003.518 3.515H309a3.517 3.517 0 003.518-3.515v-11.818z",
    stroke: "#46505C",
    strokeWidth: 1.759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M206.979 310.642h61.564c.971 0 1.759.787 1.759 1.757v41.308c0 .971-.788 1.758-1.759 1.758h-61.564a1.759 1.759 0 01-1.759-1.758v-41.308c0-.97.788-1.757 1.759-1.757z",
    fill: "#4E4E4E",
    opacity: 0.33
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M206.979 310.642h61.564c.971 0 1.759.787 1.759 1.757v41.308c0 .971-.788 1.758-1.759 1.758h-61.564a1.759 1.759 0 01-1.759-1.758v-41.308c0-.97.788-1.757 1.759-1.757z",
    fill: "#4E4E4E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M206.979 310.642h61.564c.971 0 1.759.787 1.759 1.757v41.308c0 .971-.788 1.758-1.759 1.758h-61.564a1.759 1.759 0 01-1.759-1.758v-41.308c0-.97.788-1.757 1.759-1.757z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 61.178h204.038c6.8 0 12.313 5.509 12.313 12.304v119.53c0 6.795-5.513 12.304-12.313 12.304H142.735c-6.801 0-12.313-5.509-12.313-12.304V73.482c0-6.795 5.512-12.304 12.313-12.304z",
    stroke: "#000",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 61.178h204.038c6.8 0 12.313 5.509 12.313 12.304v119.53c0 6.795-5.513 12.304-12.313 12.304H142.735c-6.801 0-12.313-5.509-12.313-12.304V73.482c0-6.795 5.512-12.304 12.313-12.304z",
    fill: "#005581"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 61.178h204.038c6.8 0 12.313 5.509 12.313 12.304v119.53c0 6.795-5.513 12.304-12.313 12.304H142.735c-6.801 0-12.313-5.509-12.313-12.304V73.482c0-6.795 5.512-12.304 12.313-12.304z",
    fill: "#005581"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 61.178h204.038c6.8 0 12.313 5.509 12.313 12.304v111.634c0 6.795-5.513 12.304-12.313 12.304H142.735c-6.801 0-12.313-5.509-12.313-12.304V73.482c0-6.795 5.512-12.304 12.313-12.304z",
    fill: "#005581",
    opacity: 0.17
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M346.773 64.69H142.735a12.317 12.317 0 00-8.707 3.603 12.3 12.3 0 00-3.606 8.7v116.015-119.53a12.3 12.3 0 013.606-8.7 12.317 12.317 0 018.707-3.604h204.038c3.266 0 6.398 1.296 8.707 3.604a12.3 12.3 0 013.606 8.7v3.516a12.3 12.3 0 00-3.606-8.7 12.317 12.317 0 00-8.707-3.605z",
    fill: "#fff"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M289.408 205.316h-14.133L170.483 61.178h14.132l104.793 144.138zm-22.285 0h-4.349L157.981 61.178h4.349l104.793 144.138z",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 61.178h204.038c6.8 0 12.313 5.509 12.313 12.304v119.53c0 6.795-5.513 12.304-12.313 12.304H142.735c-6.801 0-12.313-5.509-12.313-12.304V73.482c0-6.795 5.512-12.304 12.313-12.304z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M146.252 188.159V77.419h197.003v110.74H146.252z",
    fill: "#F52"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M276.055 188.159h-14.132l-80.511-110.74h14.132l80.511 110.74zm-22.285 0h-4.349L168.91 77.419h4.349l80.511 110.74z",
    fill: "#fff"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M146.252 188.159V77.419h197.003v110.74H146.252z",
    stroke: "#46505C",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 205.315h204.038c6.8 0 12.313 5.509 12.313 12.305v126.56c0 6.796-5.513 12.305-12.313 12.305H142.735c-6.801 0-12.313-5.509-12.313-12.305V217.62c0-6.796 5.512-12.305 12.313-12.305z",
    fill: "#E6F3FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M133.94 344.182V217.621c0-4.854 3.937-8.789 8.795-8.789h204.038c4.858 0 8.795 3.935 8.795 8.789v126.561c0 4.853-3.937 8.788-8.795 8.788H142.735c-4.858 0-8.795-3.935-8.795-8.788z",
    fill: "#fff",
    stroke: "#E6F3FF",
    strokeWidth: 1.759,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M258.87 349.612h-28.231a3.518 3.518 0 00-3.518 3.516v3.357h35.267v-3.357c0-.933-.37-1.827-1.03-2.486a3.522 3.522 0 00-2.488-1.03z",
    fill: "#E6F3FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M142.735 205.315h204.038c6.8 0 12.313 5.509 12.313 12.305v126.56c0 6.796-5.513 12.305-12.313 12.305H142.735c-6.801 0-12.313-5.509-12.313-12.305V217.62c0-6.796 5.512-12.305 12.313-12.305z",
    stroke: "#46505C",
    strokeWidth: 3.518,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M146.252 217.109h197.003a2.638 2.638 0 012.639 2.637v75.585a2.637 2.637 0 01-2.639 2.636H146.252a2.637 2.637 0 01-2.638-2.636v-75.585a2.638 2.638 0 012.638-2.637z",
    fill: "#E6F3FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M307.123 278.192h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm19.03 0h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879zm-114.184 0h86.676a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-86.676a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879zm-19.03 0h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm-27.825 6.922h7.035a.88.88 0 01.88.879v3.626a.879.879 0 01-.88.878h-7.035a.879.879 0 01-.88-.878v-3.626a.88.88 0 01.88-.879zm0-6.922h7.035a.88.88 0 01.88.879v3.626a.88.88 0 01-.88.879h-7.035a.88.88 0 01-.88-.879v-3.626a.88.88 0 01.88-.879zm-12.313 6.922h7.036c.486 0 .879.394.879.879v3.626a.878.878 0 01-.879.878h-7.036a.878.878 0 01-.879-.878v-3.626c0-.485.393-.879.879-.879zm24.625 0h7.036a.88.88 0 01.88.879v3.626a.879.879 0 01-.88.878h-7.036a.879.879 0 01-.879-.878v-3.626a.88.88 0 01.879-.879zm131.455-24.427h27.826c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-27.826a.879.879 0 01-.879-.879v-10.547c0-.485.394-.878.879-.878zm-19.189 0h10.554c.485 0 .879.393.879.878v10.547a.879.879 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.03 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.031 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.03 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.031 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879H213.57a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.031 0h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-41.738 0h31.661c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-31.661a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm143.768-18h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.394-.878.879-.878zm19.031 0h21.107c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879H315.6a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-38.062 0h10.554c.485 0 .879.393.879.878v10.547a.879.879 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.029 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.032 0h10.554c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.394-.878.879-.878zm-19.031 0H231c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.03 0h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.031 0h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-29.584 0h21.107c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-21.107a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm154.09-17.228h10.554a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.554a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm19.262 0h10.554a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.554a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm-38.523 0h10.554c.486 0 .879.393.879.879v10.547a.878.878 0 01-.879.878H287.63a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm-19.261 0h10.554c.485 0 .879.393.879.879v10.547a.879.879 0 01-.879.878h-10.554a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.261 0h10.553a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.553a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.261 0h10.554c.485 0 .879.393.879.879v10.547a.879.879 0 01-.879.878h-10.554a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.554a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm-19.261 0h10.554c.486 0 .879.393.879.879v10.547a.878.878 0 01-.879.878h-10.554a.878.878 0 01-.879-.878v-10.547c0-.486.393-.879.879-.879zm-19.261 0h10.553a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.553a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554c.485 0 .879.393.879.879v10.547a.879.879 0 01-.879.878h-10.554a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M307.123 278.192h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm19.03 0h10.554a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-10.554a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879zm-114.184 0h86.676a.88.88 0 01.88.879v10.547a.88.88 0 01-.88.879h-86.676a.88.88 0 01-.879-.879v-10.547a.88.88 0 01.879-.879zm-19.03 0h10.554a.88.88 0 01.879.879v10.547a.88.88 0 01-.879.879h-10.554a.88.88 0 01-.88-.879v-10.547a.88.88 0 01.88-.879zm-27.825 6.922h7.035a.88.88 0 01.88.879v3.626a.879.879 0 01-.88.878h-7.035a.879.879 0 01-.88-.878v-3.626a.88.88 0 01.88-.879zm0-6.922h7.035a.88.88 0 01.88.879v3.626a.88.88 0 01-.88.879h-7.035a.88.88 0 01-.88-.879v-3.626a.88.88 0 01.88-.879zm-12.313 6.922h7.036c.486 0 .879.394.879.879v3.626a.878.878 0 01-.879.878h-7.036a.878.878 0 01-.879-.878v-3.626c0-.485.393-.879.879-.879zm24.625 0h7.036a.88.88 0 01.88.879v3.626a.879.879 0 01-.88.878h-7.036a.879.879 0 01-.879-.878v-3.626a.88.88 0 01.879-.879zm131.455-24.427h27.826c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-27.826a.879.879 0 01-.879-.879v-10.547c0-.485.394-.878.879-.878zm-19.189 0h10.554c.485 0 .879.393.879.878v10.547a.879.879 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.03 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.031 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.03 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.031 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879H213.57a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.031 0h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-41.738 0h31.661c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-31.661a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm143.768-18h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.394-.878.879-.878zm19.031 0h21.107c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879H315.6a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-38.062 0h10.554c.485 0 .879.393.879.878v10.547a.879.879 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.029 0h10.553c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.553a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm-19.032 0h10.554c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-10.554a.879.879 0 01-.879-.879v-10.547c0-.485.394-.878.879-.878zm-19.031 0H231c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.03 0h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-19.031 0h10.554c.486 0 .879.393.879.878v10.547a.878.878 0 01-.879.879h-10.554a.878.878 0 01-.879-.879v-10.547c0-.485.393-.878.879-.878zm-29.584 0h21.107c.486 0 .88.393.88.878v10.547a.88.88 0 01-.88.879h-21.107a.88.88 0 01-.88-.879v-10.547c0-.485.394-.878.88-.878zm154.09-17.228h10.554a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.554a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm19.262 0h10.554a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.554a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm-38.523 0h10.554c.486 0 .879.393.879.879v10.547a.878.878 0 01-.879.878H287.63a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm-19.261 0h10.554c.485 0 .879.393.879.879v10.547a.879.879 0 01-.879.878h-10.554a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.261 0h10.553a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.553a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.261 0h10.554c.485 0 .879.393.879.879v10.547a.879.879 0 01-.879.878h-10.554a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.554a.879.879 0 01-.879-.878v-10.547c0-.486.394-.879.879-.879zm-19.261 0h10.554c.486 0 .879.393.879.879v10.547a.878.878 0 01-.879.878h-10.554a.878.878 0 01-.879-.878v-10.547c0-.486.393-.879.879-.879zm-19.261 0h10.553a.88.88 0 01.88.879v10.547a.879.879 0 01-.88.878h-10.553a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zm-19.262 0h10.554c.485 0 .879.393.879.879v10.547a.879.879 0 01-.879.878h-10.554a.879.879 0 01-.88-.878v-10.547a.88.88 0 01.88-.879zM319.51 197.42H169.998v11.817a3.516 3.516 0 003.518 3.516h142.476a3.516 3.516 0 003.518-3.516V197.42z",
    fill: "#005581"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M169.998 197.42H319.51v1.758H169.998v-1.758z",
    fill: "#fff"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M173.516 209.237h142.476a3.519 3.519 0 003.518-3.515v3.515a3.52 3.52 0 01-3.518 3.516H173.516a3.52 3.52 0 01-3.518-3.516v-3.515a3.516 3.516 0 003.518 3.515z",
    fill: "#005581",
    opacity: 0.25
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M319.51 197.42H169.998v11.817a3.516 3.516 0 003.518 3.516h142.476a3.516 3.516 0 003.518-3.516V197.42z",
    stroke: "#46505C",
    strokeWidth: 1.759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M213.972 302.362h61.564c.971 0 1.759.787 1.759 1.758v41.308c0 .971-.788 1.758-1.759 1.758h-61.564a1.759 1.759 0 01-1.759-1.758V304.12c0-.971.788-1.758 1.759-1.758z",
    fill: "#E6F3FF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M213.972 302.362h61.564c.971 0 1.759.787 1.759 1.758v41.308c0 .971-.788 1.758-1.759 1.758h-61.564a1.759 1.759 0 01-1.759-1.758V304.12c0-.971.788-1.758 1.759-1.758z",
    stroke: "#005581",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M244.754 72.732a2.637 2.637 0 11-.002-5.274 2.637 2.637 0 01.002 5.274z",
    fill: "#fff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M244.754 72.732a2.637 2.637 0 11-.002-5.274 2.637 2.637 0 01.002 5.274z",
    stroke: "#46505C",
    strokeWidth: 0.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M189.91 88.62h10.554a.88.88 0 010 1.758H189.91a.88.88 0 110-1.758zm-22.844 0h10.554a.88.88 0 110 1.758h-10.554a.88.88 0 010-1.758zm45.686 0h10.554a.879.879 0 110 1.758h-10.554a.879.879 0 110-1.758zm113.588 5.59a4.253 4.253 0 01-4.254-4.252 4.253 4.253 0 014.254-4.251 4.252 4.252 0 110 8.502z",
    fill: "#fff"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M200.289 136.504h89.033v3.203h-89.033v-3.203zm11.259-10.633h66.514v3.25h-66.514v-3.25z",
    fill: "#fff"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M229.447 161.407h25.338a4.819 4.819 0 014.821 4.817 4.82 4.82 0 01-4.821 4.818h-25.338a4.82 4.82 0 01-4.821-4.818 4.819 4.819 0 014.821-4.817z",
    stroke: "#fff",
    strokeWidth: 0.879,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingStartup);
export default __webpack_public_path__ + "static/media/pricing-startup.63f27c999ede7025f19a46322b2ffcc3.svg";
export { ForwardRef as ReactComponent };